module.exports = __webpack_public_path__ + "static/mbaner-df1f90956b3c5a79e974848acdc0af4b.png";